export default function ProgressBar({ nota = 0, pequeno = false  }) {
    return (
        <div className={`w-full ${pequeno ? "h-2" : "h-6"} relative`}>
            <div className={`w-full ${pequeno ? "h-2" : "h-6"} left-0 top-0 absolute bg-divider-medium rounded-lg`} />
            <div style={{ width: `${nota > 0.1 ? nota * 100 : 10}%` }}
                className={`${pequeno ? "h-2" : "h-6"} left-0 top-0 absolute ${nota > 0.84 ? "bg-sucess-main" : (nota > 0.49 ? "bg-warning-main" : "bg-error-main")} rounded-lg`} />
        </div>
    )
}